// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__zFqtr","row":"ProcedureTreatmentSummary_row__C3nbx"};